import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";
import AuthShell from "@/components/auth/AuthShell";
import { useAuth } from "@/lib/auth";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await forgotPassword(email.trim().toLowerCase());
      setSent(true);
    } catch (e) {
      const detail = e?.response?.data?.detail || "Could not send reset link. Please try again.";
      toast.error(detail);
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your account's email and we'll send you a reset link."
      footer={<>Remembered it? <Link to="/login" className="font-bold" style={{ color: "var(--brand)" }} data-testid="link-login">Sign in</Link></>}
    >
      {sent ? (
        <div className="flex flex-col items-center text-center gap-4" data-testid="forgot-sent">
          <div className="w-16 h-16 rounded-full flex items-center justify-center"
               style={{ background: "color-mix(in srgb, var(--brand) 12%, transparent)" }}>
            <Mail className="w-7 h-7" style={{ color: "var(--brand)" }} />
          </div>
          <p className="text-sm" style={{ color: "var(--on-surface)" }}>
            If an account exists for <b>{email}</b>, a reset link has been sent.
            Please check your inbox and spam folder.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col gap-4" data-testid="forgot-form">
          <label className="text-xs font-bold uppercase tracking-widest" style={{ color: "var(--on-surface-muted)" }}>
            Email
            <input
              type="email" required autoComplete="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-2 px-4 py-3 rounded-xl border text-base font-normal normal-case tracking-normal"
              style={{ background: "var(--card)", borderColor: "var(--border-c)", color: "var(--on-surface)" }}
              data-testid="forgot-email"
            />
          </label>
          <button
            type="submit" disabled={loading}
            className="btn btn-green mt-2 justify-center w-full"
            data-testid="forgot-submit"
          >
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Sending…</> : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
